
import { useEffect, useState } from "react"
import { useSelector } from "react-redux"

import SimpleBoxDisplay from "../../../common/SimpleBoxDisplay"
import DatepickerWithLabel from "../../../common/interactive/DatepickerWithLabel"
import { getUmPolicyLimitsLabel } from "../../../../lib/labels"
import CheckboxCell from "../../../common/interactive/CheckboxCell"
import { returnPrimaryInsuranceOrTheNextActiveOne } from "../../../../lib/primaryItemScripts"
import Grid from "../../../fragments/Grid"
import Tag from "../../../fragments/Tag"

import classes from './NegotiationRow.module.css'
import InputBoxCurrencyAlternative from "../../../common/interactive/InputBoxCurrencyAlternative"

export default function NegotiationUM({updateHandler}) {
    const activeCase = useSelector(state => state.case.activeCase) 

    const [umData, setUmData] = useState(null)

    useEffect(() => {
        
        if (activeCase && activeCase.mp_pip_um) {

            let primary = returnPrimaryInsuranceOrTheNextActiveOne(activeCase, 'mp_pip_um', 'is_um_primary_insurance')
            
            if (primary) {
                setUmData(primary)
            }
            
        }
    }, [activeCase])

    return <div className={classes.container}>
        <div className={`${classes.row} ${classes.row_header}`}>
            <h3>UM</h3>
            {umData && <div className={classes.header_side}>
                {umData.has_um ? <Tag color={'Green'}>UM</Tag> : <Tag color={'RedG'}>No UM</Tag>}
                {/* <CheckboxCell action={updateHandler} direction={'reverse'} label={'Neg. with Liab.'} checked={umData.um_neg_with_liability} identifier={{type: 'case_mp_pip_um', field: 'um_neg_with_liability', type_id: umData.id, folder: 'mp_pip_um'}} setStyle={'box_small'}/> */}
                <CheckboxCell action={updateHandler} direction={'reverse'} label={'Split'} checked={umData.um_neg_split} identifier={{type: 'case_mp_pip_um', permissionType: 'case_negotiation', field: 'um_neg_split', type_id: umData.id, folder: 'mp_pip_um'}} setStyle={'box_small'} isDisabled={umData.has_um != 1} messages={umData.has_um != 1 ? ['UM Not Available'] : null}/>
            </div>}
        </div>
        {umData && <>           
            <div className={classes.row}>
                <SimpleBoxDisplay label={'Insurance company'} value={umData.insurance_carrier?.name}/>
            </div>
            <div className={`${classes.row} ${classes.row_flex}`}>
                <SimpleBoxDisplay label={'UM Limit Patient'} value={getUmPolicyLimitsLabel(umData.um_policy_limit_patient)}/>
                <SimpleBoxDisplay label={'UM Limit Accident'} value={getUmPolicyLimitsLabel(umData.um_policy_limit_accident)}/>
            </div>
            <div className={`${classes.row}`}>
                {/* special={'negotiation_grid'} */}
                <Grid columns={2} gap={8} >
                    <DatepickerWithLabel action={updateHandler} label={'Negotiation Date '} defaultDate={activeCase?.case_negotiation?.um_negotiation_date} identifier={{type: 'case_negotiation', field: 'um_negotiation_date', type_id: null, folder: 'case_negotiation'}}/>
                    <DatepickerWithLabel action={updateHandler} label={'Case Settlement Date'} defaultDate={activeCase.case_negotiation?.um_case_settlement_date} identifier={{type: 'case_negotiation', field: 'um_case_settlement_date', type_id: null, folder: 'case_negotiation'}}/>
                </Grid>
                
            </div>
            <div className={classes.row}>
                <InputBoxCurrencyAlternative action={updateHandler} label={'UM Top Offer'} currentValue={activeCase.case_negotiation?.um_case_top_offer_from_insurance} identifier={{type: 'case_negotiation', field: 'um_case_top_offer_from_insurance', type_id: null, folder: 'case_negotiation'}}/>
            </div>
        </>}
    </div>
}